export const THEMES_REQUESTED = 'zola/wedding/website/theme_listing/THEMES_REQUESTED';
export const THEMES_RECEIVED = 'zola/wedding/website/theme_listing/THEMES_RECEIVED';
export const THEMES_RESET = 'zola/wedding/website/theme_listing/THEMES_RESET';
export const THEME_REQUESTED = 'zola/wedding/website/theme_listing/THEME_REQUESTED';
export const THEME_RECEIVED = 'zola/wedding/website/theme_listing/THEME_RECEIVED';
export const THEME_FILTER_SELECTED = 'zola/wedding/website/theme_listing/THEME_FILTER_SELECTED';
export const CHANGE_FLAG = 'zola/wedding/website/theme_listing/CHANGE_FLAG';
export const CHANGE_CURRENT_THEME = 'zola/wedding/website/theme_listing/CHANGE_CURRENT_THEME';
export const RESET_CURRENT_THEME = 'zola/wedding/website/theme_listing/RESET_CURRENT_THEME';
export const THEME_GROUP_RESET = 'zola/wedding/website/theme_listing/THEME_GROUP_RESET';
export const STORE_THEMEDETAIL_KEY = 'zola/wedding/website/theme_listing/STORE_THEMEDETAIL_KEY';
export const RESET_THEMEKEY = 'zola/wedding/website/theme/RESET_THEMEKEY';



// WEBPACK FOOTER //
// ./src/actions/types/website/ThemeListingActionTypes.js